const OrderFormTitleBar = ( { logo, formName }) => {
    const serviceImageStyle = {
        height: '8rem'        
    };

    return (
        <div className="d-flex flex-column">
            <div className="d-flex flex-row justify-content-between align-items-baseline">
            <img
                style={serviceImageStyle} 
                src={logo} alt={`logo for order form`}
            />
            <h4>
                {formName} Order Form
            </h4>

            </div>
            <div>
                <hr />
            </div>
        </div>
    )
}

export { OrderFormTitleBar };